import type { Landmark } from '../../../data/types';
import type { Ring } from '../../../geo/types';
import { conventRangeRect } from './conventRange';
import { corners } from './genericBlock';
import reading from './sintLucienPlan.json';
import { toLayout, type PlanFrame } from './planFrame';

export function sintLucienReading(landmark: Landmark) {
  if (landmark.id !== 'landmark-sint-lucien') throw new Error(`No Luciën plan for ${landmark.id}`);
  return reading;
}

export function sintLucienFrame(landmark: Landmark): PlanFrame {
  const x = landmark.params['anchorX'],
    y = landmark.params['anchorY'];
  if (typeof x !== 'number' || typeof y !== 'number')
    throw new Error(`${landmark.id} lacks its component anchor`);
  return { origin: [x, y], heading: landmark.heading, ring: [] };
}

export function sintLucienRangeFrame(
  plan: PlanFrame,
  part: { readonly u: number; readonly v: number; readonly angleDeg: number }
): PlanFrame {
  return {
    origin: toLayout(plan, [part.u, part.v]),
    heading: plan.heading + (part.angleDeg * Math.PI) / 180,
    ring: [],
  };
}

/** Only built bodies get foundations; court and burial ground stay open. */
export function sintLucienFoundations(landmark: Landmark): Ring[] {
  const plan = sintLucienFrame(landmark);
  return [
    ...sintLucienReading(landmark).chapel.map((p) => corners(p).map((q) => toLayout(plan, q))),
    ...sintLucienReading(landmark).ranges.map((p) =>
      corners(conventRangeRect(p)).map((q) => toLayout(sintLucienRangeFrame(plan, p), q))
    ),
  ];
}

export const sintLucienObstacles = sintLucienFoundations;

export function sintLucienFloors(landmark: Landmark) {
  const plan = sintLucienFrame(landmark);
  return sintLucienReading(landmark).floors.map((f) => ({
    ...f,
    ring: f.ring.map((p) => toLayout(plan, [p[0]!, p[1]!])),
  }));
}
